import { TemplateRef } from '@angular/core';

export class SelectItem<T = any> {
  id?: number;
  index?: number;
  name?: string;
  value?: any;
  classes?: string;
  hasCustom?: boolean;
  template?: TemplateRef<any>;
  isActive?: boolean;
  extraOptions?: T;
  childs?: SelectItem[];

  constructor(model: SelectItem) {
    this.id = model.id || 0;
    this.index = model.index || 0;
    this.name = model.name || '';
    this.value = model.value;
    this.classes = model.classes || '';
    this.hasCustom = model.hasCustom || false;
    this.template = model.template || (null as any);
    this.isActive = model.isActive || true;
    this.extraOptions = model.extraOptions || (null as any);
    this.childs = model.childs || (null as any);
  }
}

export enum VerticalDirection {
  Top = 1,
  Bottom = 2,
}

export class PriorityArrayItem<T> {
  fieldName?: string;
  value?: T;
  direction?: VerticalDirection;

  constructor(model: PriorityArrayItem<T>) {
    this.fieldName = model.fieldName || '';
    this.value = model.value;
    this.direction = model.direction || VerticalDirection.Top;
  }
}

export enum FSActionElementType {
  Link = 1,
  Button = 2,
}

export enum FsColorPalette {
  Primary = 1,
  Success = 2,
  Warning = 3,
  Danger = 4,
  Black = 5,
  LightGray = 6,
}

export declare type FsColorPaletteSymbols =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'black'
  | 'light-gray'
  | '';

export declare type FsWidthSymbols =
  | 'unset'
  | 'inherit'
  | 'max-content'
  | 'min-content'
  | string;

export class FSActionElement<V> {
  id?: number;
  type?: FSActionElementType;
  name?: string;
  value?: V;
  role?: string;
  classes?: string;
  isActive?: boolean;
  action?: () => {};

  constructor(model: FSActionElement<V>) {
    this.id = model.id || 0;
    this.type = model.type || FSActionElementType.Button;
    this.name = model.name || '';
    this.value = model.value || (null as any);
    this.role = model.role || '';
    this.classes = model.classes || '';
    this.isActive = model.isActive || true;
    this.action = model.action || (null as any);
  }
}

export enum InlinePosition {
  Start = 1,
  Center = 2,
  End = 3,
}

export enum AlignPosition {
  Default = 0,
  InlineStart = 1,
  InlineCenter = 2,
  InlineEnd = 3,
  BlockStart = 4,
  BlockCenter = 5,
  BlockEnd = 6,
}

export interface IBoundingClientRect {
  bottom?: number;
  height?: number;
  left?: number;
  right?: number;
  top?: number;
  width?: number;
  x?: number;
  y?: number;
}

export class ElementEvent<V> {
  event?: any;
  value?: V;

  constructor(model: ElementEvent<V>) {
    this.event = model.event || (null as any);
    this.value = model.value || (null as any);
  }
}

export class FsOverlayOptions {
  parentEl: HTMLElement;
  contentRef: HTMLElement;
  contentItemsCount: number;
  maxItemsPerView?: number;
  leftOffset?: number;
  topOffset?: number;
  width?: number;
  classes?: string;

  constructor(model: FsOverlayOptions) {
    this.parentEl = model.parentEl;
    this.contentRef = model.contentRef;
    this.contentItemsCount = model.contentItemsCount;
    this.maxItemsPerView = model.maxItemsPerView || 8;
    this.leftOffset = model.leftOffset || 0;
    this.topOffset = model.topOffset || 0;
    this.width = model.width || 0;
    this.classes = model.classes || '';
  }
}

export class FsOverlayContentOptions {
  parentRect: IBoundingClientRect;
  contentRect: IBoundingClientRect;
  parentOptions: FsOverlayOptions;
  overlayContainer: HTMLElement;

  constructor(model: FsOverlayContentOptions) {
    this.parentRect = model.parentRect;
    this.contentRect = model.contentRect;
    this.parentOptions = model.parentOptions;
    this.overlayContainer = model.overlayContainer;
  }
}

export class FsDragEndEvent {
  oldIndex?: number;
  newIndex?: number;

  constructor(model: FsDragEndEvent) {
    this.oldIndex = model.oldIndex || 0;
    this.newIndex = model.newIndex || 0;
  }
}

export enum SortDirection {
  Default = 0,
  ASC = 1,
  DESC = 2,
}

export class SortOption {
  direction?: SortDirection;
  field?: string;

  constructor(model: SortOption) {
    this.direction = model.direction || SortDirection.ASC;
    this.field = model.field || '';
  }
}
